import {
  BlogPublicPost,
  blogImageUrl,
  blogPostHref,
  formatBlogDate,
} from '@/lib/entities/blog';

import Link from 'next/link';

import styles from './ArticleCard.module.scss';
import { BlogCover } from './BlogCover';

type ArticleCardProps = {
  post: BlogPublicPost;
  locale: string;
  readingLabel: string;
};

export const ArticleCard = ({
  post,
  locale,
  readingLabel,
}: ArticleCardProps) => {
  const imageUrl = blogImageUrl(post.imageKey);
  const date = formatBlogDate(post.publishedOn, locale);

  return (
    <Link
      href={blogPostHref(post)}
      className={styles.card}
      aria-label={post.pageTitle}
    >
      <BlogCover
        imageUrl={imageUrl}
        className={styles.card__cover}
        sizes="(max-width: 768px) 100vw, 33vw"
      />
      <div className={styles.card__body}>
        <div className={styles.card__top}>
          <h3 className={styles.card__title}>{post.pageTitle}</h3>
          {post.introText ? (
            <p className={styles.card__excerpt}>{post.introText}</p>
          ) : null}
        </div>
        <p className={styles.card__meta}>
          {readingLabel}
          {date ? ` • ${date}` : ''}
        </p>
      </div>
    </Link>
  );
};
